import * as React from 'react';
import { Routes } from 'react-router-dom';
import { FaroRoutes } from '@grafana/faro-react';
import { usePreviousLocationTracker } from 'Util/_HumanWritten/Navigation/previousLocation';
import { isFaroInitialized } from './observability';

/**
 * Drop-in for react-router's <Routes> that adds Faro route-change tracking.
 * FaroRoutes depends on the router hooks registered during initializeFaro, so when
 * Faro is not initialized (local dev, tenants without observability config) this
 * must fall back to the plain <Routes> — rendering FaroRoutes uninitialized would
 * dereference router dependencies that were never set.
 *
 * It also drives the app-wide previous-pathname tracker. This is the single highest
 * component that both sits inside the router (so `useLocation` works) and renders on
 * every route change, which is exactly what the tracker needs — it must update before
 * any routed component renders. See `Util/_HumanWritten/Navigation/previousLocation.ts`.
 */
export const ObservabilityRoutes: React.ComponentType<React.ComponentProps<typeof Routes>> = props => {
	usePreviousLocationTracker();

	return isFaroInitialized() ? <FaroRoutes {...props} /> : <Routes {...props} />;
};
